import React from "react";
import PropTypes from "prop-types";
import { buildScopeTranslate } from "lib/I18n";

const tTopBar = buildScopeTranslate("views.content.assessment_framework.assessments.pages.top_bar");

const AssessmentFrameworkTopBar = ({ title = "", showTitle = false, onReturnToTrail }) => (
  <nav aria-label={tTopBar("navigation_label")} className="th-agentforce-assessment__top-bar">
    <button
      type="button"
      className="slds-button th-agentforce-assessment__top-bar-back"
      onClick={onReturnToTrail}
      aria-label={tTopBar("return_to_trail")}>
      <tds-icon symbol="chevronleft" size="small" aria-hidden="true"></tds-icon>
      <span className="th-agentforce-assessment__top-bar-back-label">
        {tTopBar("return_to_trail")}
      </span>
    </button>

    {showTitle && (
      <div className="th-agentforce-assessment__top-bar-title">
        {title}
      </div>
    )}
  </nav>
);

AssessmentFrameworkTopBar.propTypes = {
  title: PropTypes.string,
  showTitle: PropTypes.bool,
  onReturnToTrail: PropTypes.func.isRequired,
};

export default AssessmentFrameworkTopBar;
